module.exports = __webpack_public_path__ + "img/check2-all.dad3c91f.svg";